<script setup>
import { ref } from 'vue';
import Icon from '@/Components/Icon/index.vue';
const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
});

const open = ref(props.isOpen);

const beforeEnter = (el) => {
  el.style.height = '0';
};
const enter = (el) => {
  el.style.height = el.scrollHeight + 'px';
};
const beforeLeave = (el) => {
  el.style.height = el.scrollHeight + 'px';
};
const leave = (el) => {
  el.style.height = '0';
};
</script>

<template>
  <div>
    <button
      class="bg-grey-200 rounded-none px-5 py-4 h-fit w-full flex text-left justify-between items-center text-primary text-base font-au-sans-medium"
      type="button"
      data-bs-toggle="collapse"
      @click="open = !open"
    >
      <slot name="title" />
      <Icon
        :class="{'scale-y-[-1]': open}"
        class="transition ease-out duration-150 pointer-events-none"
        path="ChevronDown"
        :height="24"
        :width="24"
      />
    </button>
    <Transition
      name="accordion"
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div
        v-if="open"
        class="overflow-hidden px-5 py-4 transition-all duration-150 ease-out"
      >
        <div class="break-words">
          <slot name="content" />
        </div>
      </div>
    </Transition>
  </div>
</template>
